import SectionHead from '../section/SectionHead.react';

class Contact extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            name    : '',
            email   : '',
            subject : '',
            message : ''
        };

        this.onNameChange = this.onNameChange.bind(this);
        this.onEmailChange = this.onEmailChange.bind(this);
        this.onSubjectChange = this.onSubjectChange.bind(this);
        this.onMessageChange = this.onMessageChange.bind(this);
        this.submitForm = this.submitForm.bind(this);
    }

    onNameChange(e) {
        this.setState({ name : e.target.value });
    }

    onEmailChange(e) {
        this.setState({ email : e.target.value });
    }

    onSubjectChange(e) {
        this.setState({ subject : e.target.value });
    }

    onMessageChange(e) {
        this.setState({ message : e.target.value });
    }

    submitForm() {
        var error = false;

        if (this.state.name.length < 1) {
            $('#nameLabel').css({ opacity : 1 });
            error = true;
        }

        if (!this.validateEmail(this.state.email)) {
            $('#emailLabel').css({ opacity : 1 });
            error = true;
        }

        if (this.state.message.length < 1) {
            $('#messageLabel').css({ opacity : 1 });
            error = true;
        }

        if (!error) {
            var formData = new FormData();
            formData.append('contactName', this.state.name);
            formData.append('contactEmail', this.state.email);
            formData.append('contactSubject', this.state.subject);
            formData.append('contactMessage', this.state.message);

            $.ajax({
                url: '/inc/sendEmail.php',
                data: formData,
                cache: false,
                contentType: false,
                processData: false,
                type: 'POST',
                }).done(function(data) {
                    // console.log('done', data)
                    if (data === 'OK') {
                        $('.contact__message').text('Your message was sent, thank you!');
                    } else {
                        $('.contact__message').text('Something went wrong, please try again later!');
                    }

                    setTimeout(() => {
                        $('.contact__message').text('');
                    }, 10000);

                }).fail(function(response, type, message) {
                    console.log('errro')
                });
        }
    }

    validateEmail(email) {
        var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email);
    }

    render() {
        var content = this.props.content;

        // console.log('content', content);

        return (
            <section
                className='section contact'
                id='contact'>

                <SectionHead
                    className='white'
                    title={content.header.title} />

                <div className='row'>

                    <div className='contact__left'>

                        <div className='contact__contact-form'>

                            <input
                                name='contactName'
                                type='text'
                                id='contactName'
                                placeholder='Name'
                                value={this.state.name}
                                onChange={this.onNameChange}
                                onFocus={() => { $('#nameLabel').css({ opacity : 0}) } }
                                minLength='2'
                                required
                                label='this is required' />

                            <div className='contact__label' id='nameLabel'>This field is required</div>

                            <input
                                name='contactEmail'
                                type='email'
                                id='contactEmail'
                                placeholder='Email'
                                value={this.state.email}
                                onChange={this.onEmailChange}
                                onFocus={() => { $('#emailLabel').css({ opacity : 0}) } }
                                required />

                            <div className='contact__label' id='emailLabel'>This field is required</div>

                            <input
                                name='contactSubject'
                                type='text'
                                id='contactSubject'
                                placeholder='Subject'
                                value={this.state.subject}
                                onChange={this.onSubjectChange} />

                            <textarea
                                name='contactMessage'
                                id='contactMessage'
                                placeholder='Message'
                                rows='10'
                                cols='50'
                                value={this.state.message}
                                onChange={this.onMessageChange}
                                onFocus={() => { $('#messageLabel').css({ opacity : 0}) } }
                                required >
                            </textarea>

                            <div className='contact__label' id='messageLabel'>At least 15 characters is required</div>

                            <div
                                className='contact__submit'
                                onClick={this.submitForm}>

                                Submit
                            </div>

                            <div className='contact__message' />

                        </div>

                    </div>

                    <div className='contact__right'>

                        <p className='contact__lead'>{content.text}</p>

                        <h3 className='address'>Come Visit</h3>

                        { content.address[0].line1 &&
                            <p>{content.address[0].line1}</p>
                        }
                        { content.address[1].line2 &&
                            <p>{content.address[1].line2}</p>
                        }
                        { content.address[2].line3 &&
                            <p>{content.address[2].line3}</p>
                        }
                        { content.address[3].line4 &&
                            <p>{content.address[3].line4}</p>
                        }

                        <h3>Call Us:</h3>

                        { content.tel[0].line1 &&
                            <p>{content.tel[0].line1}</p>
                        }
                        { content.tel[1].line2 &&
                            <p>{content.tel[1].line2}</p>
                        }
                        { content.tel[2].line3 &&
                            <p>{content.tel[2].line3}</p>
                        }
                        { content.tel[3].line4 &&
                            <p>{content.tel[3].line4}</p>
                        }

                    </div>

                    <div className='clear' />
                </div>
            </section>
        );
    }
}

export default Contact;



// WEBPACK FOOTER //
// ./ui_src/app/components/contact/Contact.react.jsx